import React from 'react'
import { connect } from 'react-redux'
import { isEqual, sortBy } from 'lodash'
import moment from 'moment'
import { withRouter, RouteComponentProps } from 'react-router'
import * as metricService from '../services/metrics'
import { trace } from '../services/common'
import { VALIDATION_PATTERNS, CACHE_PREFIX } from '../config'
import { selectGroupsList } from '../selectors/groups'
import { AppStateType } from '../reducers'
import { IGroup } from '../types/group'

interface ILocationTracker {
  groupsList: IGroup[]
}

class LocationTrackerComponent extends React.Component<
  RouteComponentProps<any> & ILocationTracker
> {
  private unlisten

  public async componentDidMount() {
    await this.checkLocation(this.props.location.pathname)
    metricService.sendLoggingMetric(this.props.location.pathname)
    this.unlisten = this.props.history.listen(async (newLocation, action) => {
      await this.checkLocation(newLocation.pathname)
    })
  }

  public async componentDidUpdate(prevProps) {
    if (!isEqual(sortBy(this.props.groupsList), sortBy(prevProps.groupsList))) {
      await this.checkLocation(this.props.location.pathname)
    }
  }

  public componentWillUnmount() {
    this.unlisten()
  }

  public render() {
    return null
  }

  private checkLocation = async (pathname: string) => {
    const matchArr = pathname.match(VALIDATION_PATTERNS.GROUP_PATH)
    if (!matchArr || matchArr.index !== 0) {
      return
    }

    const groupName = matchArr[0].split('/')[2]
    const groupKey = `${CACHE_PREFIX}${groupName}_group_last_visited_day`
    const lastDayVisited = localStorage.getItem(groupKey)
    const momentNow = moment.utc()
    if (lastDayVisited) {
      const lastDayVisitedMoment = moment.utc(lastDayVisited)
      const isSameDay = lastDayVisitedMoment.isSame(momentNow, 'day')
      if (isSameDay) {
        return
      }
    }

    const groupExists = this.props.groupsList.some(
      (group) => group.name === groupName
    )
    if (!groupExists) {
      return
    }

    try {
      await metricService.createGroupUserActivityMetric(groupName)
      localStorage.setItem(groupKey, momentNow.format())
    } catch (error) {
      trace(error)
    }
  }
}

const mapStateToProps = (state: AppStateType, ownProps) => ({
  groupsList: selectGroupsList(state),
})

export const LocationTracker = withRouter(
  connect(mapStateToProps)(LocationTrackerComponent)
)
